export function logger (_messaging) {
  console.log(_messaging)
}

export default {
  logger
}
